<template>
    <div>
        <FilterTable 
          :resource_name="resource_name"
          :title="title"
          :field_definitions="field_definitions"
          :filters="filters"
          :action_buttons="action_buttons"
          :row_actions="row_actions"
          :translate_to_display_data="translate_to_display_data"
          :route_root="route_root"
          :handle_row_action="handle_row_action"
          :full_text_search="false"
          :handle_action_button_click="handle_action_button_click"
          :resource_identifier="resource_identifier"
          :update_flag="filter_table_update_flag"
        />
        <el-dialog
          title=""
          :visible.sync="dialog_visible"
          width="30%"
          center>
          <DigitalObjectDetailPage 
            :resource_name="resource_name"
            :route_root="route_root"
            :type="article_type"
            :resource_identifier="do_resource_identifier"
            :host_resource_identifier="resource_identifier"
            :dialog_visible="dialog_visible"
            @cancel="dialog_visible=false"
            mode="view"
            @update:update_flag="handle_do_update"
            :dialog_refersh="dialog_refersh_flag"
          />
        </el-dialog>
    </div>
</template>

<script>
// @ is an alias to /src
//import Main from '@/components/backstage/Main.vue'
import FilterTable from '@/components/backstage/FilterTable/FilterTable.vue'
import DigitalObjectDetailPage from '@/views/backstage/pages/DigitalObjectDetailPage.vue'
import axios from 'axios'
import api from '@/api/index'

  export default {
    components: {
      FilterTable,
      DigitalObjectDetailPage
    },
    props: ['article_type','article_id'],
    data() {
      return {
        resource_name: 'article/do',
        resource_api: process.env.VUE_APP_API_BACKSTAGE_URL + '/article/do',
        title: '數位物件管理',
        route_root: 'digital-resource-management',
        digital_object_id: '',
        dialog_visible: false,
        dialog_refersh_flag: 0,
        resource_identifier: {
          name: 'fk_article_system_id',
          value: this.article_id,
          form: 'json'
        },
        field_definitions: [
          {
            display: {
              name: '編號',
              type: 'string',
              //width: '100px',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'id',
              data_type: 'string',
            } 
          },
          {
            display: {
              name: '檔案類型',
              type: 'string',
              //width: '100px',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'digital_type',
              data_type: 'digital_type',
            } 
          },
          {
            display: {
              name: '縮圖',
              type: 'image',
              //width: '100px',
              sortable: false,
            },
            source: {
              type: 'db',
              key: 'preview_image_url_150',
              data_type: 'string',
            }
          },
          {
            display: {
              name: '檔案名稱',
              type: 'string',
              //width: '100px',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'original_image_name',
              data_type: 'string',
            }
          },
          {
            display: {
              name: '敘述',
              type: 'string',
              //width: '100px',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'description',
              data_type: 'string',
            }
          },
        ],
        filters: {
          '檔案類型': {
            paramName: 'digital_type',
            value: null,
            options: {
                type: 'fixed',
                list: [
                  { label: '圖片', value: 'image' },
                  { label: '文件', value: 'doc' },
                  { label: '影片', value: 'video' },
                  { label: '音訊', value: 'audio' },
                ]
            }
          },
        },
        action_buttons: {
        },
        row_actions: {
          get: {
            label: '檢視',
            action: 'get'
          },
          download: {
            label: '下載',
            action: 'download',
            enable: (row) => this.check_row(row)
          }
        },
        filter_table_update_flag: 0
      }
    },
    computed: {
      do_resource_identifier: function () {
          return {
            name: 'id',
            value: this.digital_object_id
          }
      },
    },
    methods: {
      check_row(row) {
        if(row.digital_type == '文件') {
          return true
        }else {
          return false
        }
      },
      handle_row_action (action, index, row) {
        console.log('DetailPageDigitalObjectTab: action:' + action + ', index: ' + index + ', row: ', row)

        switch(action){
          case 'get': 
            this.digital_object_id = row.id
            this.dialog_visible = true
            this.dialog_refersh_flag += 1
            break
          case 'download': 
            this.handle_do_doc_download(row.id)
            break  
          default:
            break
        }
      },
      handle_action_button_click (action) {
        console.log('DetailPageDigitalObjectTab: action button clicked: ', action)

        switch(action){
          case 'batch_download': 
            break
          default:
            break
        }
      },
      handle_do_update () {
        this.filter_table_update_flag += 1
      },
      async handle_do_doc_download(id) {
        this.loading = true
        let res = await api.download_article_do_doc(id)
        if(res.success === true){
            this.notify_message(this.ERROR.LEVEL.SUCCESS, '下載文件成功')
        }else {
            this.notify_message(this.ERROR.LEVEL.ERROR, '下載文件失敗', res.message)
        }
        this.loading = false
      },
    }
  };
</script>

<style>
</style>
